import { queryClient } from '@/queries';
import { missionPlannerQueries } from '@/queries/mission-planner';

export const suggestedQueries = {
  getBenchmarkPlanById: (planId: string) => queryClient.fetchQuery(missionPlannerQueries.benchmarkByPlanId(planId)),
  getRoutePlansById: (planId: string) => queryClient.fetchQuery(missionPlannerQueries.routesByPlanId(planId)),
  getCommercialFlightsById: (planId: string) =>
    queryClient.fetchQuery(missionPlannerQueries.commercialFlightsById(planId)),
  getSurgeonRoutesByPlanId: (planId: string) =>
    queryClient.fetchQuery(missionPlannerQueries.surgeonRoutesByPlanId(planId)),
  getPartialRoutePlanById: (planId: string) =>
    queryClient.fetchQuery(missionPlannerQueries.partialRouteByPlanId(planId)),
  getPartialCommercialFlightsById: (planId: string) =>
    queryClient.fetchQuery(missionPlannerQueries.partialCommercialFlightsById(planId)),
};
